<!-- Wrapper for location card -->
<div class="location-card ">
  <div class="loc-name" [ngClass]="{'loc-name-min-height':!isMobileView}">{{ location.name }}</div>

  <span class="distance" *ngIf="location.distanceFromRequestedLocation"
    >{{ location.distanceFromRequestedLocation }}
    {{ unitOfDistance | translate }}</span
  >
<!-- <div class="loc-secondary-info"> -->
  <div class="loc-secondary-info" [ngClass]="{'loc-secondary-info-min-height': !isMobileView}">
    <!-- <div class="loc-address info-text" [class.locimageaddress]="showLocationImage">{{ location.address }}</div> -->
    <div class="loc-address info-text" [ngClass]="{'locimageaddress':showLocationImage , 'info-text-min-height':!isMobileView}">{{ location.address }}</div>
    <div class="loc-image-outer" *ngIf="showLocationImage">
      <img
        *ngIf="location.imageUrl"
        src="{{ imageBaseUrl + location.imageUrl}}"
        alt="loc Image"
      />
    </div>
 </div>
  <div class="delivery"  [ngClass]="{'delivery-min-height':!isMobileView}">
    <span class="info-text">
      <ng-container
        *ngFor="let serviceType of location.servicesSupported; let i = index"
        >{{ serviceType | translate }}
        <ng-container *ngIf="i != location.servicesSupported.length - 1"
          >,
        </ng-container>
      </ng-container>
    </span>
  </div>

  <!-- <div class="loc-image-outer" *ngIf="showLocationImage">
    <img
      *ngIf="location.imageUrl"
      src="{{ imageBaseUrl + location.imageUrl}}"
      alt="loc Image"
    />
  </div> -->
<!-- </div> -->
  <div class="location-status" [ngClass]="{'location-status-min-height':!isMobileView}">
    <span class="info-text">
      <ng-container
        *ngIf="location.isLocationOpen && location.allow; else closedLoc"
      >
        <span class="open-status"> {{ 'Open' | translate }}</span>
        <span> {{ 'Until' | translate }} </span>
        <span>{{ location.openUntil | time24to12Transform }} <ng-container *ngIf="location.openUntilDay">, {{location.openUntilDay}}</ng-container></span>
      </ng-container>
      <ng-template #closedLoc>
        <ng-container *ngIf="location?.orderSettings?.futureOrder?.isAllow; else permClosed">
          <span class="open-status"> {{ 'future-available' | translate }}</span>
        </ng-container>
        <ng-template #permClosed>
          <span class="closed-status"> {{ 'Closed' | translate }}</span>
          <span class="closed-status" *ngIf="!location.isOpen">
            {{ 'temporarily' | translate }}</span
          >
        </ng-template>
      </ng-template>


      <!-- <br>
      <span class="closed-permenent" *ngIf="!location.isOpen">
        {{ 'next-tobedetermined' | translate }}</span> -->
    </span>
  </div>

  <button
    class="loc-info sub-text-decoration"
    data-qa="location-info"
    (click)="openLocationInfoView()"
  >
    {{ 'location_info' | translate }}
  </button>

  <span
    class="prep-time info-text"
    ><ng-container *ngIf="location.isLocationOpen && location.allow && location?.preprationTime && location.preprationTime != '0 - 0'">{{ 'preparation-time' | translate }}
    {{ getPreparationTime(location) }} mins</ng-container></span
  >

  <div class="actions" >
    <!-- deleted since this feature is not implemented -->
    <!-- <img
      class="favorite-icon"
      [src]="location.favourite ? icon.favoriteIcon : icon.nonFavoriteIcon"
      (click)="toggleLocationFavorite(location._id, location.favourite)"
      alt="favorite"
    /> -->
    <div class="button-group" >
      <!-- <button
        class="action-item order-later"
        (click)="futureOrderFromOrganization(location)"
        [ngClass]="{ disable: !location?.orderSettings?.futureOrder?.isAllow }"
        data-qa="order-later"
      >
        <img [src]="icon.orderForLater" class="item-image" alt="order for later"/>
        <span class="info-text">{{ 'order-later' | translate }}</span>
      </button>
      <button
        class="action-item order-now"
        [attr.data-qa]="'navigate-home-button-' + location._id"
        [class.disable]="!location.isLocationOpen"
        (click)="orderNowFromLocation(location)"
        [ngClass]="{
          disabled:
            !(
              !location?.orderSettings?.asapOrder?.isAllow &&
              !location?.orderSettings?.futureOrder?.isAllow
            ) && !location?.orderSettings?.asapOrder?.isAllow
        }"
      >
        <img class="item-image" [src]="icon.orderHereWhite" alt="item"/>
        <span class="info-text">{{ 'order-now' | translate }}</span>
      </button> -->
      <div class="fav-icon-section">
        <div class="fav-image" >
          <img *ngIf="!location.isFavorited"  src="assets/images/favourite_outlined.svg"  [ngClass]="location.iconLoading ? 'fav-icon-image-pulse-animate' : ''" alt="Unfavourite Image"  (click)="favouriteLocationToggle(location)"/>
          <img *ngIf="location.isFavorited" src="assets/images/favourite_filled.svg" [ngClass]="location.iconLoading ? 'fav-icon-image-pulse-animate' : ''" alt="Favourite Image"  (click)="favouriteLocationToggle(location)"/>
          <!-- <div class="loader"></div> -->
        </div>        
        <button
          class="action-item order-later sub-text-decoration"
          (click)="getlocation(location.loc[0], location.loc[1])"
        >
          {{ 'get-directions' | translate }}
        </button>
      </div>
      <!-- <img src="assets/images/checked-heart.png" class="item-image" alt="order for later" width="30" height="30" (click)="favouriteLocationToggle(location)"/> -->
      <!-- <button
      class="action-item order-later sub-text-decoration"
      (click)="getlocation(location.loc[0], location.loc[1])"
    >
      {{ 'get-directions' | translate }}
    </button> -->
      <button
        class="action-item order-now"
        [attr.data-qa]="'navigate-home-button-' + location._id"
        (click)="orderFromLocation(location)"
      >
        <img class="item-image" [src]="icon.orderHereWhite" alt="order here"/>
        <span class="info-text">{{ 'order' | translate }}</span>
      </button>
    </div>    
    
  </div>
  <!-- <ng-container *ngIf="openPicker">
    <moduurnv2-future-picker
      [openPicker]="openPicker"
      (selectedTime)="getFutureDate($event)"
    ></moduurnv2-future-picker>
  </ng-container> -->
  <!-- <moduurnv2-location-info
    [location]="location"
    (closeEvent)="closeLocationInfoView()"
  ></moduurnv2-location-info> -->
</div>

<!-- <div class="location-loading"></div> -->